export default {
	APTO_PRICING: 'https://docs.aptopayments.com/docs/concepts/overview#pricing',
	APTO_PRIVACY_POLICY: 'https://aptopayments.com/privacy/',
	APTO_TOS: 'https://aptopayments.com/terms-of-service',
};
